import React from "react";
import { Upload} from "lucide-react";
import ATMTextField from "../../../Atom/ATMTextField/ATMTextField";
const colors = ["#22c55e", "#a855f7", "#f97316", "#ec4899", "#3b82f6"];

const AddServiceForm = ({
  providers,
  formikProps,
}) => {
  const categories = [
    "Automotive Services & Products",
    "Art, Crafts & Collectibles",
    "Baby Care",
    "Bakery",
    "Books, Stationery & Toys",
    "Clothing",
    "Consultants",
    "Dentist",
    "Electronics",
    "Estate Agents",
    "Fashion, Apparel & Accessories",
    "Food",
    "Furniture",
    "Groceries",
    "Health, Wellness & Fitness",
    "Home, Living & Kitchen",
    "Others",
    "Personal Care",
    "Pet Care Services & Supplies",
    "Professional & Business Services",
    "Rent & Hire",
    "Restaurants",
    "Sports & Outdoors",
    "Other Services & Consultations",
  ];

  const { values, setFieldValue } = formikProps;


  return (
    <div className="px-6 py-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="space-y-6">
          <div className="space-y-6">
            <h4 className="text-lg font-semibold text-gray-800 border-b pb-2">
              Basic Details
            </h4>
            <ATMTextField
              name="name"
              label="Service Name"
              required
              placeholder="Enter service name"
            />
            <ATMTextField
              required
              name="description"
              label="Description"
              placeholder="Describe the service..."
              as="textarea"
            />
          </div>

          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-800 border-b pb-2">
              Category & Color
            </h4>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <div className="flex justify-between items-center">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Category *
                  </label>
                </div>
                <select
                  name="category"
                  value={values.category}
                  onChange={(e) => setFieldValue("category", e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-orange-500"
                >
                  <option value="">Select category</option>
                  {categories?.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Color Tag
                </label>
                <div className="flex gap-2 items-center">
                  {colors?.map((color) => (
                    <button
                      key={color}
                      type="button"
                      onClick={() => setFieldValue("colorCode", color)}
                      className={`w-8 h-8 rounded-full ${
                        values.colorCode === color
                          ? "ring-2 ring-offset-2 ring-gray-500"
                          : ""
                      }`}
                      style={{ backgroundColor: color }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-800 border-b pb-2">
              Duration & Price
            </h4>
            <div className="grid grid-cols-2 gap-4">
              <ATMTextField
                name="duration"
                label="Duration (min)"
                type="number"
                required
              />
              <ATMTextField
                name="bufferTime"
                label="Buffer Time"
                type="number"
              />
              <ATMTextField
                name="price"
                label="Price ($)"
                type="number"
                required
              />
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-800 border-b pb-2">
              Assign Providers
            </h4>
            <div className="grid grid-cols-2 gap-3">
              {providers?.map((provider) => (
                <button
                  key={provider.id}
                  type="button"
                  onClick={() => {
                    const updated = values.providers.includes(provider.id)
                      ? values.providers.filter((id) => id !== provider.id)
                      : [...values.providers, provider.id];
                    setFieldValue("providers", updated);
                  }}
                  className={`px-4 py-3 rounded-lg text-sm transition-colors ${
                    values.providers.includes(provider.id)
                      ? "bg-orange-50 text-orange-700 border-2 border-orange-500"
                      : "bg-gray-50 text-gray-700 border-2 border-gray-200 hover:border-orange-200"
                  }`}
                >
                  {provider.name}
                </button>
              ))}
            </div>
          </div>
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-gray-800 border-b pb-2">
              Service Image
            </h4>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center">
              {values.image.length > 0 ? (
                <div className="space-y-4 w-full">
                  {values.image?.map((img, index) => (
                    <div key={index} className="relative">
                      <img
                        src={
                          typeof img === "string"
                            ? img
                            : URL.createObjectURL(img)
                        }
                        alt={`Preview ${index}`}
                        className="h-48 w-full object-cover rounded-lg mb-2"
                      />
                      <button
                        type="button"
                        onClick={() => {
                          const updatedImages = values.image.filter(
                            (_, i) => i !== index
                          );
                          setFieldValue("image", updatedImages);
                        }}
                        className="text-red-500 text-sm absolute top-1 right-1 bg-white px-2 py-0.5 rounded"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  <div className="text-center">
                    <Upload className="mx-auto h-12 w-12 text-gray-400" />
                    <label className="cursor-pointer mt-4">
                      <span className="text-orange-500 hover:text-orange-600">
                        Upload image
                      </span>
                      <input
                        type="file"
                        className="hidden"
                        accept="image/*"
                        multiple
                        onChange={(e) => {
                          setFieldValue("image", [
                            ...values.image,
                            e.currentTarget.files[0],
                          ]);
                        }}
                      />
                    </label>
                  </div>
                </div>
              ) : (
                <div className="text-center">
                  <Upload className="mx-auto h-12 w-12 text-gray-400" />
                  <label className="cursor-pointer mt-4">
                    <span className="text-orange-500 hover:text-orange-600">
                      Upload image
                    </span>
                    <input
                      type="file"
                      className="hidden"
                      accept="image/*"
                      multiple
                      onChange={(e) => {
                        setFieldValue("image", [
                          ...values.image,
                          e.currentTarget.files[0],
                        ]);
                      }}
                    />
                  </label>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddServiceForm;
